module.exports = __webpack_public_path__ + "img/lsy.130b15b4.png";